import {
  componentZIndexes,
  makeStyles,
} from "@inductiveautomation/ws-components";

export const getPublicProfileStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.neutral[20],
    minHeight: "100vh",
  },
  snackbarPortal: {
    position: "relative",
    zIndex: componentZIndexes.SNACKBAR_Z_INDEX,
  },
  contents: {
    margin: "auto",
    maxWidth: "48rem",
    position: "relative",
    padding: "0 1.5rem 3.5rem 1.5rem",

    marginTop: "-8.5rem",

    [theme.breakpoints.down("md")]: {
      paddingBottom: "1.625rem",
    },

    [theme.breakpoints.down(480)]: {
      marginTop: "-5rem",
    },
  },

  trainingHeading: {
    ...(theme.typography.h1 as React.CSSProperties),
    color: theme.palette.brand["ia-gray"],
    marginTop: "3.5rem",
    marginBottom: "0.25rem",
  },
  trainingDescription: {
    marginBottom: "2rem",
  },
  trainingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
}));

export const getProfileWidgetStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  leftContent: {
    display: "flex",
    flexDirection: "column",
    padding: "1.5rem",
    gap: "0.5rem",
    alignItems: "center",
    justifyContent: "center",

    borderRight: `1px solid ${theme.palette.neutral[30]}`,

    [theme.breakpoints.down("sm")]: {
      borderRight: 0,
      borderBottom: `1px solid ${theme.palette.neutral[30]}`,
    },
  },
  leftContentOnly: {
    flex: 1,
    borderRight: 0,
    [theme.breakpoints.down("sm")]: {
      borderRight: 0,
      borderBottom: 0,
    },
  },
  rightContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const ITEM_BANNER_BREAKPOINT = 480;

export const getBannerStyles = makeStyles<{ baseAssetUrl: string }>()(
  (theme, { baseAssetUrl }) => ({
    root: {
      position: "relative",
      height: "12rem",
      background: theme.palette.neutral[30],

      [theme.breakpoints.down(ITEM_BANNER_BREAKPOINT)]: {
        height: "7rem",
      },
    },
    image: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "12rem",

      [theme.breakpoints.down(ITEM_BANNER_BREAKPOINT)]: {
        height: "7rem",
      },

      background: `url(${baseAssetUrl}img/authentication_bg.jpg)`,
    },
    bottomBackground: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "6rem",

      [theme.breakpoints.down(ITEM_BANNER_BREAKPOINT)]: {
        height: "2.5rem",
      },

      background: theme.palette.neutral[20],
      borderTopLeftRadius: "1rem",
      borderTopRightRadius: "1rem",
    },
  })
);

export const getUserDataWidgetStyles = makeStyles()((theme) => ({
  userCardData: {
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",

    "> div": {
      display: "flex",
      flexDirection: "row",
      gap: "0.5rem",

      svg: {
        color: theme.palette.neutral[50],
      },
    },
  },
  shareButton: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
  },
}));

export const getCertificationsWidgetStyles = makeStyles()((theme) => ({
  rightContentScrollView: {
    maxHeight: "166px",
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      height: "166px",
    },
  },
}));

export const getFooterStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "2.5rem",
    padding: "2rem 0 2rem 0",

    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      padding: "2rem 1.5rem 2rem 1.5rem",
    },
  },
  companyInformation: {
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    marginBottom: "0.625rem",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "1rem",
    },

    span: {
      ...(theme.typography.button1 as React.CSSProperties),
      color: theme.palette.neutral[60],

      [theme.breakpoints.down("sm")]: {
        ...(theme.typography.button2 as React.CSSProperties),
        color: theme.palette.neutral[60],
      },

      a: {
        textDecoration: "none",
        color: theme.palette.neutral[60],

        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  },
  separator: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  terms: {
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",

    marginBottom: "1.5rem",

    p: {
      ...(theme.typography.button2 as React.CSSProperties),
      color: theme.palette.neutral[60],

      [theme.breakpoints.down("sm")]: {
        ...(theme.typography.button2 as React.CSSProperties),
        color: theme.palette.neutral[60],
      },

      a: {
        textDecoration: "none",
        color: theme.palette.neutral[60],

        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  },
  copyright: {
    p: {
      ...(theme.typography.body2 as React.CSSProperties),
      color: theme.palette.neutral[60],

      [theme.breakpoints.down("sm")]: {
        ...(theme.typography.body3 as React.CSSProperties),
        color: theme.palette.neutral[60],
      },
    },
  },
  oneLineCopyright: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  wrappedCopyright: {
    display: "none",
    textAlign: "center",

    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));
